/*
 * File: finishOneClickInscription.ts
 * Project: meki
 * File Created: Tuesday, 27th October 2020 12:53:23 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Friday, 22nd July 2022 3:30:59 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */

import { gql } from '@apollo/client';
import { PaymentMethod } from '@interfaces';
import { ResolverParams } from '@queries/queries.interfaces';

export const finishOneClickInscription = (name: string) => gql`
  mutation ${name} ($params: FinishOneClickInscriptionParams!) {
    finishOneClickInscription(params: $params) {
      id
      uuid
      type
      data
    }
  }
`;

export type FinishOneClickInscriptionResponse = {
  finishOneClickInscription: PaymentMethod;
};

export type FinishOneClickInscriptionParams = ResolverParams<{
  token: string;
  orderUuid?: string;
}>;
